import React from 'react';
import Skeleton from 'components/LoadingSkeleton';
import classNames from 'styles/utils/classNames';

const SubscriptionStatusLoading: React.FC<{ className?: string }> = ({ className }) => {
  return (
    <div className={classNames('flex flex-col gap-3 px-6 py-4', className)}>
      <Skeleton height={20} width="100%" />
      <Skeleton height={20} width="30%" />
      <Skeleton height={40} width="100%" className="flex-1" />
      <Skeleton height={40} width="100%" className="flex-1" />
    </div>
  );
};

export default SubscriptionStatusLoading;
